export const isEmpty = (s?: string) => {
    return !s || s.length === 0
}
